import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.banking.feature-sets.CreatePaymentMethodForm'

export default defineMessages({
  newPaymentMethodTitle: {
    id: `${scope}.newPaymentMethodTitle`,
    defaultMessage: 'New payment method',
  },
  vendorLabel: {
    id: `${scope}.vendorLabel`,
    defaultMessage: 'Vendor:',
  },
  usDomesticTitle: {
    id: `${scope}.usDomesticTitle`,
    defaultMessage: 'US domestic',
  },
  usDomesticDescription: {
    id: `${scope}.usDomesticDescription`,
    defaultMessage:
      'Pay with domestic ACH, Check or Wire using your Procurify financial account or linked bank account.',
  },
  canadianDomesticTitle: {
    id: `${scope}.canadianDomesticTitle`,
    defaultMessage: 'Canadian domestic',
  },
  canadianDomesticDescription: {
    id: `${scope}.canadianDomesticDescription`,
    defaultMessage:
      'Pay Canadian bank accounts using EFT (electronic funds transfer) payments with your Procurify financial account or linked bank account.',
  },
  externalPaymentMethodTitle: {
    id: `${scope}.externalPaymentMethodTitle`,
    defaultMessage: 'External payments',
  },
  externalPaymentMethodDescription: {
    id: `${scope}.externalPaymentMethodDescription`,
    defaultMessage:
      'For approving and tracking payments outside of Procurify. These payment methods cannot be used to make payments within Procurify.',
  },
  internationalUsTitle: {
    id: `${scope}.internationalUsTitle`,
    defaultMessage: 'International',
  },
  internationalUsDescription: {
    id: `${scope}.internationalUsDescription`,
    defaultMessage:
      'Pay an international bank account with SWIFT or local payment rails using your Procurify financial account or linked bank account.',
  },
  procurifyBillPaymentsLabel: {
    id: `${scope}.procurifyBillPaymentsLabel`,
    defaultMessage: 'Procurify Bill Payments',
  },
  authCodeError: {
    id: `${scope}.authCodeError`,
    defaultMessage: 'Failed to authenticate',
  },
  errorToastTitle: {
    id: `${scope}.errorToastTitle`,
    defaultMessage: 'Error',
  },
  airwallexPaymentMethodCreatedSuccessMessage: {
    id: `${scope}.airwallexPaymentMethodCreatedSuccessMessage`,
    defaultMessage: 'Payment method created',
  },
  createAirwallexPaymentMethodErrorMessage: {
    id: `${scope}.createAirwallexPaymentMethodErrorMessage`,
    defaultMessage: 'Failed to create payment method',
  },
})
